import * as React from 'react';

import * as api from '@gitbook/api-client';
import {
    ActionableContainer,
    Group,
    Heading,
    Panel,
    PanelBody,
    Switch,
} from '@gitbook/spine-react';

import { useSiteContext, useUpgradeSite } from '../../../../state';
import { PaidFeatureIndicator } from '../../../Site';
import type { SitesCustomizationPanelProps } from '../../types';
import { FooterCopyright } from './FooterCopyright';
import { FooterLogoSettings } from './FooterLogoSettings';
import { FooterNavigation } from './FooterNavigation';

// @site-footer - Keep it synced with backend by grepping that tag.

export function PanelFooter(props: SitesCustomizationPanelProps): React.ReactElement {
    const { settings, setSettings } = props;
    const [wantsFooter, setWantsFooter] = React.useState(false);

    const hasFooterDefined =
        !!settings.footer.copyright || settings.footer.groups.length > 0 || !!settings.footer.logo;
    const opened = wantsFooter || hasFooterDefined;
    const { site } = useSiteContext();
    const upgrade = useUpgradeSite(site, api.SiteFeatureKey.SitesAdvancedCustomization);

    return (
        <Panel>
            <ActionableContainer orientation="horizontal">
                <Group>
                    <Heading>Footer</Heading>
                    <PaidFeatureIndicator upgrade={upgrade} isFeatureActive={hasFooterDefined} />
                </Group>
                <Switch
                    value={opened}
                    onValueChange={(checked) => {
                        if (!checked) {
                            setSettings((prev) => ({
                                ...prev,
                                footer: {
                                    groups: [],
                                },
                            }));
                        }

                        setWantsFooter(checked);
                    }}
                />
            </ActionableContainer>
            {opened && (
                <PanelBody>
                    <FooterLogoSettings {...props} />
                    <FooterCopyright {...props} />
                    <FooterNavigation {...props} />
                </PanelBody>
            )}
        </Panel>
    );
}
